import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { COMPANY_OVERVIEW_NAMES } from 'components/BusinessToolForm/Sections/Overview/CompanyOverview/utils/form';
import { FUNDING_NEEDS_NAMES } from 'components/BusinessToolForm/Sections/Overview/FundingNeedsOverview/utils/form';
import { COMPANY_PROJECT_NAMES } from 'components/BusinessToolForm/Sections/Overview/ProjectOverview/utils/form';

import { ul } from '../helpers';

const OVERVIEW_COMPANY_INSTRUCTIONS = {
  [COMPANY_OVERVIEW_NAMES.LIFE_CYCLE_STAGES]: {
    name: 'Етап життєвого циклу',
    instruction:
      'Стисло вкажіть поточний етап життєвого циклу вашої компанії, зазначивши, чи перебуває вона на стадії ідея, розробка, зростання чи зрілості.',
  },
};

const OVERVIEW_PROJECT_INSTRUCTIONS = {
  [COMPANY_PROJECT_NAMES.STATUS]: {
    name: 'Статус проєкту',
    instruction: `Оберіть відповідний етап:
      ${ul([
        'Оцінка ідеї: Визначення здійсненності та потенціалу бізнес-ідеї.',
        'Дослідження та розробка: Створення прототипів, тестування та проведення детальних ринкових або технічних досліджень.',
        'Вибір стратегії: Аналіз різних стратегій або моделей і вибір найбільш підходящої.',
        'Фінансування: Забезпечення необхідних фінансових ресурсів для підтримки проєкту.',
        'Впровадження: Виконання бізнес-плану та запуск продукту або послуги.',
        'Операційна діяльність: Управління щоденними операціями та забезпечення ефективного функціонування бізнесу.',
      ])}`,
    exampleOne: 'Вибір стратегії',
    exampleTwo: 'Впровадження',
  },
};

const FUNDING_NEEDS_INSTRUCTIONS = {
  [FUNDING_NEEDS_NAMES.FUNDING_DIRECTIONS]: {
    name: 'Напрями фінансування',
    instruction:
      'Вкажіть розподіл бюджету для кожної мети: R&D, Маркетинг, Оборотний капітал, Будівництво, Обладнання.',
    exampleOne: '',
    exampleTwo: '',
  },
};

export const OVERVIEW_INSTRUCTIONS = {
  [BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.COMPANY]: OVERVIEW_COMPANY_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.PROJECT]: OVERVIEW_PROJECT_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.FUNDING_NEEDS]: FUNDING_NEEDS_INSTRUCTIONS,
};
